export abstract class GridPaginationBase<T> {
  public currentPage = 1;
  public totalPages = 1;
  public pageSize = 10;
  public filtroActivo = false;
  public terminoBusqueda = '';

  protected actualizarPaginacion(totalFilas: number): void {
    this.totalPages = Math.max(1, Math.ceil(totalFilas / this.pageSize));
    this.currentPage = Math.min(this.currentPage, this.totalPages);
  }

  public filtrarTabla(value: string): void {
    this.terminoBusqueda = value || '';
    this.currentPage = 1;
    this.aplicarFiltro();
  }

  public toggleFiltro(): void {
    this.filtroActivo = !this.filtroActivo;
    if (!this.filtroActivo) {
      this.terminoBusqueda = '';
    }
    this.aplicarFiltro();
  }

  public primeraPagina(): void { this.currentPage = 1; }
  public ultimaPagina(): void { this.currentPage = this.totalPages; }
  public paginaAnterior(): void { if (this.currentPage > 1) this.currentPage--; }
  public paginaSiguiente(): void { if (this.currentPage < this.totalPages) this.currentPage++; }

  protected abstract aplicarFiltro(): void;
}
